{
	"invalid_number": "The card number is not a valid credit card number",
	"invalid_expiry_month": "The card’s expiration month is invalid",
	"invalid_expiry_year": "The card’s expiration year is invalid",
	"invalid_cvc": "The card’s security code is invalid",
	"incorrect_number": "The card number is incorrect",
	"incomplete_number": "The card number is incomplete",
	"incomplete_cvc": "The card’s security code is incomplete",
	"incomplete_expiry": "The card’s expiration date is incomplete",
	"expired_card": "The card has expired",
	"incorrect_cvc": "The card’s security code is incorrect",
	"incorrect_zip": "The card’s postcode failed validation",
	"invalid_expiry_year_past": "The card’s expiration year is in the past",
	"card_declined": "The card was declined",
	"missing": "There is no card on a customer that is being charged",
	"processing_error": "An error occurred while processing the card"
}
